import { SavedSearch, ResponseMakeModelType } from '../../../../../types';
import {
  IGetAdsRequestFilter,
  IGetAdsRequestRange,
} from '../../../../../api/types/searchPageApiTypes';
import { groupTrimsByModelsByMake } from '../../../../../features/filters/Filters.mapper';
import { getFiltersUrl } from '../../../../../features/filters/Filters.helper';
import { MakeModelTrimValues } from './url.typed';
import { typeSafeObjectKeys } from '@dist-marketplace-frontend/utils';

const mapMakeModelFilters = (
  makeModelSavedSearchFilters?: ResponseMakeModelType,
): MakeModelTrimValues[] => {
  if (!makeModelSavedSearchFilters) return [];
  const modelsByMake = makeModelSavedSearchFilters
    ? groupTrimsByModelsByMake(makeModelSavedSearchFilters)
    : {};

  return typeSafeObjectKeys(modelsByMake).map((item) => ({
    makeValue: item,
    modelValue: modelsByMake[item] ? [...modelsByMake[item]] : [],
  }));
};

export const getSavedSearchUrl = (savedSearch: SavedSearch) => {
  const {
    sections,
    sort,
    terms,
    makeModelFilters,
    ranges,
    filters,
    andFilters = [],
    geoFilter,
  } = savedSearch.search;

  const makeModelFiltersSearch = makeModelFilters as {
    make: string;
    model: string;
    trim: string;
  }[];

  if (sections) {
    const url = getFiltersUrl(
      sections[0],
      {
        ...(sort && {
          sort: sort.toLowerCase(),
        }),
        ...(terms && {
          words: terms,
        }),
      },
      filters as IGetAdsRequestFilter[],
      andFilters as IGetAdsRequestFilter[],
      mapMakeModelFilters(makeModelFiltersSearch),
      ranges as IGetAdsRequestRange[],
      geoFilter?.countyTown,
      geoFilter?.rad.toString(),
      geoFilter?.county,
    );
    return `${url}&saved`;
  }
};
